import { Calendar, Users, MapPin } from 'lucide-react';

/**
 * LpTrustStrip — Thin credibility band displayed below the hero on each LP.
 *
 * Brand-consistent phrasing (verified against existing site):
 *   • "Since 1988"  — matches SEOSchema.foundingDate + OurStory + IRSTranscriptReport ("Practicing since 1988")
 *   • "100,000+ businesses helped"  — confirmed by firm (Session 41 R10, Feb 2026)
 *   • "Carolinas · all 50 states"  — matches IRSTranscriptReport eyebrow + OurStory office list
 *
 * Style mirrors IRSTranscriptReport "track-record-stats" pattern: ivory tile,
 * gold icon, small uppercase eyebrow label, semi-bold value, soft slate description.
 *
 * Mobile: stacks vertically; desktop: 3-up grid.
 */
const TRUST_ITEMS = [
  {
    icon: Calendar,
    eyebrow: "Established",
    value: "Since 1988",
    label: "38 years of CPA practice",
  },
  {
    icon: Users,
    eyebrow: "Track record",
    value: "100,000+",
    label: "businesses & individuals served",
  },
  {
    icon: MapPin,
    eyebrow: "Reach",
    value: "Carolinas · all 50 states",
    label: "Charlotte · Winston-Salem · Mooresville",
  },
];

export const LpTrustStrip = () => {
  return (
    <section
      className="bg-[#F7F6F2] border-y border-[#E8E5DC] py-6 sm:py-8"
      data-testid="lp-trust-strip"
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-5">
          {TRUST_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="flex items-start gap-3 rounded-xl bg-white border border-[#E8E5DC] px-4 py-3.5 sm:px-5 sm:py-4"
                data-testid={`lp-trust-item-${i}`}
              >
                <span className="mt-0.5 inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#C9A961]/15">
                  <Icon className="h-4.5 w-4.5 text-[#C9A961]" strokeWidth={2} />
                </span>
                <div className="min-w-0">
                  <div className="font-['Inter'] text-[10px] font-semibold tracking-[0.18em] uppercase text-[#C9A961] mb-0.5">
                    {item.eyebrow}
                  </div>
                  <div className="text-[#0B2240] font-semibold text-sm sm:text-base leading-snug">
                    {item.value}
                  </div>
                  <div className="text-[#4C5A70] text-xs sm:text-sm mt-0.5 leading-snug">
                    {item.label}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
